var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.$route.name == 'View' ? { height: '100vh' } : ''),attrs:{"id":_vm.$route.name == 'WenKu' || _vm.$route.name == 'Result'
      ? 'newapp'
      : _vm.$route.name == 'NewHome'
      ? 'homeapp'
      : 'app'}},[(_vm.$route.name != 'NewHome')?_c('Header'):_vm._e(),_vm._v(" "),_c('router-view'),_vm._v(" "),(_vm.$route.name != 'NewHome' && _vm.$route.name != 'WenKu')?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-303204c4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 